import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

const routes = [
    {
        path: 'students',
        element: <List />
    },
    {
        path: 'students/create',
        element: <Create />
    },
    {
        path: 'students/edit/:id',
        element: <Edit />
    }
]
export default routes;